
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./ShellApp": () => {
return Promise.all([__webpack_require__.e(3317), __webpack_require__.e(9783), __webpack_require__.e(3002), __webpack_require__.e(9731), __webpack_require__.e(4591), __webpack_require__.e(7872), __webpack_require__.e(8441), __webpack_require__.e(3994)]).then(() => (() => (__webpack_require__(15366))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };